import type { FormValues } from '@/modules/donate/form/FormValues.interface';

export const getInitialFormState: FormValues = {
	amount: 10,
	certificated: false,
	customAmount: '',
	defaultAmountOptions: {},
	repeatedEmail: '',
	email: '',
	language: 'SPA',
	region: '',
	city: '',
	documentNumber: '',
	documentType: 'id',
	streetNumber: '',
	streetType: '',
	streetName: '',
	additionalInfo: '',
	country: '',
	postalCode: '',
	company: '',
	province: '',
	name: '',
	lastName: '',
	subscribeNewsletter: false,
	donationHolder: 'individual',
	additionalInfoRequired: false,
	termsAndConditions: false,
	ngoTermsAndConditions: false,
	telefonicaTermsAndConditions: false,
	checkbox: [],
	dedicateToMessage: '',
	metafields: { tickets: 0, noTicket: false },
};
